import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import { mainColor, whiteColor } from "../../../assets/colors/color";
import TabListBoxT from "./TabLsitBoxT";
import TabListBoxS from "./TabLsitBoxS";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function TabList({ edata, selectedDate }) {
  const tabs = ["운송", "기선STS"];
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const Tedata = edata.filter((data) => {
    return data.shipType === "운송";
  });
  const Sedata = edata.filter((data) => {
    return data.shipType === "기선STS";
  });

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: `${mainColor}` }}>
        <AntTabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          textColor="secondary"
          indicatorColor="secondary"
        >
          {tabs.map((tab, idx) => (
            <AntTab key={idx} label={tab} {...a11yProps(0)} />
          ))}
        </AntTabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <TabListBoxT edata={Tedata} selectedDate={selectedDate} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <TabListBoxS edata={Sedata} selectedDate={selectedDate} />
      </CustomTabPanel>
    </Box>
  );
}

const AntTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    flex: 1,
    padding: "15px 0",
    minWidth: "25%",
    borderRadius: "10px 10px 0 0",
    fontFamily: ["Noto Sans KR", "sans-serif"],
    whiteSpace: "pre-line",
    fontSizs: 20,
    fontSize: 17,
    fontWeight: 500,
    "&:hover": {
      color: `${mainColor}`,
      opacity: 1,
    },
    "&.Mui-selected": {
      backgroundColor: `${mainColor}`,
      color: `${whiteColor}`,
    },
    "&.Mui-focusVisible": {
      backgroundColor: `${mainColor}`,
    },
  })
);

const AntTabs = styled(Tabs)({
  borderBottom: `2px solid ${mainColor}`,
  whiteSpace: "pre-line",
});
